<template>
  <div
      v-if="!hasPermission('List Availability') && !hasPermission('List AvailWeek') && !hasPermission('List Availability Block')">
    Você não tem permissão para acessar esta página!
  </div>
  <div v-else>

    <Toolbar/>

    <div class="d-flex ms-5">
      <ul class="nav nav-pills flex-column">

        <li class="nav-item">
          <a href="#" class="nav-link text-center mb-2 p-2 border border-primary"
             :class="{'active': activeTab === 'releaseTimes'}"
             @click="activeTab = 'releaseTimes';">Liberação de Horários</a>
        </li>

        <li class="nav-item">
          <a href="#" class="nav-link text-center mb-2 p-2 border border-primary"
             :class="{'active': activeTab === 'placeTimes'}"
             @click="activeTab = 'placeTimes'; ">Horário de Funcionamento</a>
        </li>

      </ul>

      <div v-show="activeTab === 'releaseTimes'" class="container-xxl">
        <div class="card">
          <div class="mx-5">
            <div class="mt-5">
              <div class="row">
                <div class="col-md-3">
                  <label for="">Profissional</label>
                  <select class="form-select form-control-solid" aria-label="Selecionar Profissional"
                          v-model="currentProfessionalId"
                          :disabled="!canChangeProfessional"
                          @change="selectProfessional();">
                    <option :value="professional.id_prof" v-for="professional in selectableProfessionals"
                            :key="professional.id_prof">
                      {{ professional.prof_name }}
                    </option>
                  </select>
                </div>
                <div v-if="!unifyAvail" class="col-md-3">
                  <label for="">Especialidade</label>
                  <select class="form-select form-control-solid" aria-label="Selecionar especialidade"
                          v-model="specId" @change="changeSpecId(specId)">
                    <option :value="specialty.id_spec" v-for="specialty in specialties">
                      {{ specialty.spec_name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3" v-show="!specialty?.kind_exam">
                  <label for="release_for">Liberar Horário para</label>
                  <select class="form-select form-control-solid" aria-label="Liberar Horário para"
                          :disabled="lastKindExam" id="release_for" @change="refresh=true;" v-model="releaseFor">
                    <option value="B">Teleconsulta e presencial</option>
                    <option value="F">Presencial</option>
                    <option value="O">Teleconsulta</option>
                  </select>
                </div>
                <div class="col-md-3" v-show="releaseFor !== 'O' && locations && locations.length > 0">
                  <label for="id_place_location" class="d-flex align-items-center">
                    Unidade de Atendimento
                    <i class="bi bi-info-circle ms-2 text-muted" 
                       data-bs-toggle="tooltip" 
                       data-bs-placement="top"
                       title="A unidade selecionada será aplicada às novas liberações de horário"></i>
                  </label>
                  <div class="btn-group w-100">
                    <button type="button" 
                            class="btn btn-light form-control form-control-solid text-start d-flex align-items-center justify-content-between"
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                            :style="getLocationButtonStyle()">
                      <span class="d-flex align-items-center">
                        <span class="location-color-indicator me-2" 
                              :style="getLocationColorStyle(selectedLocationId)"></span>
                        {{ getLocationName(selectedLocationId) }}
                      </span>
                      <i class="bi bi-chevron-down"></i>
                    </button>
                    <ul class="dropdown-menu w-100 shadow-lg" style="max-height: 300px; overflow-y: auto;">
                      <li>
                        <button class="dropdown-item d-flex align-items-center py-2 px-3"
                                type="button"
                                @click="selectedLocationId = null"
                                :class="{'active': selectedLocationId === null}">
                          <span class="location-color-indicator me-2" 
                                :style="getLocationColorStyle(null)"></span>
                          {{ place?.place_name || 'Local Principal' }}
                        </button>
                      </li>
                      <li><hr class="dropdown-divider my-1"></li>
                      <li v-for="location in locations" :key="location.id_place_location">
                        <button class="dropdown-item d-flex align-items-center py-2 px-3"
                                type="button"
                                @click="selectedLocationId = location.id_place_location"
                                :class="{'active': selectedLocationId === location.id_place_location}">
                          <span class="location-color-indicator me-2" 
                                :style="getLocationColorStyle(location.id_place_location)"></span>
                          {{ location.location_nickname || location.location_name }}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-2" v-show="!specialty?.kind_exam && specialty?.perm_return">
                  <label for="perm_return">Permite Retorno?</label>
                  <select class="form-select form-control-solid" id="perm_return"
                          :disabled="lastKindExam" v-model="allowReturn" @change="refresh=true;">
                    <option :value="null">-----</option>
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <button class="btn btn-flex btn-primary m-1 mt-8 mt-lg-7" type="button"
                          title="Agendamentos" @click="this.$router.push('/schedules');">
                    <i class="bi bi-calendar-week"></i>
                    <span class="d-block d-lg-none">Voltar para a agenda</span>
                  </button>
                  <button class="btn btn-flex btn-success m-1 mt-8 mt-lg-7" type="button"
                          title="Resumo de Disponibilidade" @click="showSummaryModal = true;">
                    <i class="bi bi-file-earmark-text"></i>
                    <span class="d-block d-lg-none">Resumo</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <ul class="nav nav-tabs mb-6 border-4 fw-bold">
              <li class="nav-item" v-if="hasPermission('List Availability')">
                <a class="nav-link active" data-bs-toggle="tab" href="#tab-time" @click="refresh=true;">
                  <span class="d-none d-lg-inline-block">Horário</span> Individual</a>
              </li>

              <li class="nav-item" v-if="hasPermission('List Availability')">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-period" @click="refresh=true;">
                  <span class="d-none d-lg-inline-block">Data</span>
                </a>
              </li>

              <li class="nav-item" v-if="hasPermission('List AvailWeek')">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-week">
                  <span class="d-none d-lg-inline-block">Dia da</span> Semana
                </a>
              </li>
              <li class="nav-item" v-if="hasPermission('List Availability Block')">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-unavailability">
                  Bloqueio
                </a>
              </li>
            </ul>

            <div class="tab-content w-100">
              <div class="tab-pane fade show active" id="tab-time" role="tabpanel">
                <AvailTime
                    :professional="professional"
                    :spec-id="specId"
                    :allow-return="allowReturn"
                    :release-for="releaseFor"
                    :selected-location-id="selectedLocationId"
                    :refresh="refresh"
                    @onRefreshed="refresh=false">
                </AvailTime>
              </div>

              <div class="tab-pane fade" id="tab-period" role="tabpanel">
                <AvailPeriod
                    :professional-id="currentProfessionalId"
                    :professional="professional"
                    :spec-id="specId"
                    :allow-return="allowReturn"
                    :release-for="releaseFor"
                    :selected-location-id="selectedLocationId"
                    :refresh="refresh"
                    :interval-minutes="specialty?.interval_minutes??professional?.interval_minutes"
                    :specialties="specialties"
                    :allow-replication="!unifyAvail"
                    @onRefreshed="refresh=false">
                </AvailPeriod>
              </div>

              <div class="tab-pane fade" id="tab-week" role="tabpanel">
                <AvailWeek
                    :professional-id="currentProfessionalId"
                    :spec-id="specId"
                    :allow-return="allowReturn"
                    :release-for="releaseFor"
                    :selected-location-id="selectedLocationId"
                    :refresh="refresh"
                    :interval-minutes="specialty?.interval_minutes??professional?.interval_minutes"
                    :specialties="specialties"
                    :allow-replication="!unifyAvail"
                    @onRefreshed="refresh=false">
                </AvailWeek>
              </div>
              <div class="tab-pane fade" id="tab-unavailability" role="tabpanel">
                <Unavailability
                    :current-professional-id="currentProfessionalId">
                </Unavailability>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="activeTab === 'placeTimes'" class="container-xxl">
        <div class="card">
          <div class="card-body">
            <AvailWeekPlace
                :intervalMinutes=30>
            </AvailWeekPlace>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal" id="summaryModal" v-if="showSummaryModal" @click.self="showSummaryModal = false" style="display: block; background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Resumo das Disponibilidades</h5>
          <button type="button" class="btn-close" @click="showSummaryModal = false;"></button>
        </div>
        <div class="modal-body">
          <SummaryAvail
              :professional="professional">
          </SummaryAvail>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mask} from "vue-the-mask";
import http from "../../../helpers/http";
import AvailWeek from "./tab/AvailWeek.vue";
import AvailWeekPlace from "./tab/AvailWeekPlace.vue";
import AvailTime from "./tab/AvailTime.vue";
import Unavailability from "./tab/Unavailability.vue";
import Permission from "../../../helpers/permission";
import Toolbar from "../../../components/layouts/auth/Toolbar.vue";
import Alert from "@/helpers/alert";
import AvailPeriod from "./tab/AvailPeriod.vue";
import SummaryAvail from "./tab/SummaryAvail.vue";
import { generateColorFromId } from "@/helpers/colorGenerator";

export default {
  name: "ReleaseTimes",
  components: {
    AvailPeriod,
    Unavailability,
    AvailWeek,
    AvailWeekPlace,
    AvailTime,
    Toolbar,
    SummaryAvail,
  },
  directives: {
    mask,
  },
  data() {
    return {
      activeTab: 'releaseTimes',
      refresh: false,
      releaseFor: 'F',
      allowReturn: false,
      specId: '',
      specialties: [],
      professional: {},
      specialty: {},
      currentProfessionalId: '',
      lastKindExam: true,
      unifyAvail: false,
      showSummaryModal: false,
      locations: [],
      selectedLocationId: null,
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    canChangeProfessional() {
      if (this.userAuth?.is_admin) {
        return true;
      }

      return !this.userAuth?.id_prof;
    },
    selectableProfessionals() {
      if (this.canChangeProfessional) {
        return this.professionals;
      }

      const ownId = this.userAuth?.id_prof;
      if (ownId) {
        const ownProfessionals = this.professionals.filter(p => p.id_prof === ownId);
        if (ownProfessionals.length > 0) {
          return ownProfessionals;
        }
      }

      if (this.professionals.length > 0) {
        return [this.professionals[0]];
      }

      return [];
    },
  },
  mounted() {
    this.loadLocations();
    if (this.professionals.length > 0) {
      this.currentProfessionalId = this.resolveInitialProfessionalId();
      this.selectProfessional();
    } else {
      Alert.error('Nenhum profissional encontrado. Verifique se há profissionais cadastrados.');
    }
  },
  watch: {
    place() {
      this.loadLocations();
    },
  },
  methods: {
    date: moment,
    hasPermission(permission) {
      return Permission.has(permission);
    },
    resolveInitialProfessionalId() {
      const selectable = this.selectableProfessionals;
      if (selectable.length === 0) {
        return '';
      }

      const ownId = this.userAuth?.id_prof;
      if (ownId && selectable.some(p => p.id_prof === ownId)) {
        return ownId;
      }

      return selectable[0].id_prof;
    },
    selectProfessional() {
      let professional = this.professionals.find(p => p.id_prof === this.currentProfessionalId);
      this.professional = professional;
      this.releaseFor = this.lastKindExam ? 'F' : professional?.default_release_time_for;
      this.allowReturn = professional.returning_deadline > 0;
      this.unifyAvail = professional.unify_avail;

      this.loadSpecialties();
    },
    loadSpecialties() {
      http.get(`/places/${this.place.id_place}/professionals/${this.currentProfessionalId}/specialties`).then((response) => {
        this.specialties = response.data;

        if (this.specialties.length === 0) {
          Alert.error('Nenhuma especialidade cadastrada para o profissional selecionado.');
          return;
        }

        this.specId = this.specialties[0].id_spec;
        if (this.specialties.length > 0) {
          this.lastKindExam = this.specialties[0].kind_exam;
        }
        this.changeSpecId(this.specId);

        this.refresh = true;
      });
    },
    loadLocations() {
      if (!this.place?.id_place) {
        return;
      }
      http.get(`/places/${this.place.id_place}/locations`).then((response) => {
        this.locations = response.data || [];
      }).catch(() => {
        this.locations = [];
      });
    },
    changeSpecId(specId) {
      this.specialty = this.specialties.find(spec => spec.id_spec === specId) ?? {};
      let kindExam = this.specialty?.kind_exam;
      if (kindExam !== this.lastKindExam) {
        this.lastKindExam = kindExam;
      }
      this.releaseFor = kindExam ? 'F' : this.professional?.default_release_time_for;

      this.refresh = true;
    },
    getLocationColorStyle(locationId) {
      const color = generateColorFromId(locationId);
      return {
        backgroundColor: color,
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        display: 'inline-block',
        flexShrink: 0,
      };
    },
    getLocationButtonStyle() {
      return {};
    },
    getLocationName(locationId) {
      if (locationId === null) {
        return this.place?.place_name || 'Local Principal';
      }
      const location = this.locations.find(loc => loc.id_place_location === locationId);
      return location ? (location.location_nickname || location.location_name) : '';
    },
  }
}
</script>

<style scoped>
.nav-pills .nav-link {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
}

.location-color-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.dropdown-item.active {
  background-color: var(--bs-primary);
  color: var(--bs-white);
}

.dropdown-item.active .location-color-indicator {
  border-color: rgba(255, 255, 255, 0.5);
}

.dropdown-item:hover {
  background-color: var(--bs-light);
}

.dropdown-item:hover .location-color-indicator {
  transform: scale(1.1);
  transition: transform 0.2s;
}
</style>